import moment from 'moment'
import { z } from 'zod'

/**
 * 当選メッセージキューAPI Zodスキーマ定義
 */

/** 配信バッチの抽出ウィンドウ（1分幅・cron 30分間隔）の取りこぼしを防ぐための余裕 */
export const SCHEDULE_LEAD_MINUTES = 5

/**
 * 配信開始日時。
 */
export const actionDatetimeSchema = z
  .string()
  .datetime({ offset: true })
  .refine(value => moment(value).isSameOrAfter(moment().add(SCHEDULE_LEAD_MINUTES, 'minute')))
